import { Divider } from '@cfa/react-components';

const FilterDivider = () => <Divider className="w-full" variant="fullLength" />;

export default FilterDivider;
